<template>
  <a :href="url" class="featured-article__wrapper" target="_blank">
    <div class="featured-article__image-wrapper">
      <img :src="image" class="featured-article__image"/>
    </div>
    <div class="featured-article__info">
      <div class="featured-article__text"> {{ text }} </div>
      <div class="featured-article__title"> {{ title }} </div>
    </div>
  </a>
</template>

<script>
export default {
  name: "FeaturedArticle",
  props: {
    image: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>